import { HandleProductBasedNavUpdatePayload } from '../../../types/Navigation/HandleProductBasedNavUpdatePayload';
import { setDisabledPage } from './setDisabledPage';

export async function handleProductBasedNavUpdate(payload: HandleProductBasedNavUpdatePayload): Promise<string> {
  const { selectedProduct, patientInfo } = payload;
  if (selectedProduct === 'Self Guided Package') {
    setDisabledPage({ name: 'guided', value: true, patientInfo: patientInfo });
    // // ----------UNLOCK THE PAGE AFTER THE THANKS PAGE, BUT KEEP IT DISABLED ----------
    // // TURN THE NAVIGATION OBJECT INTO AN ARRAY
    // const navArray = Object.entries(patientInfo.navObj).map(([key, value]) => {
    //   return { [key]: { ...value } };
    // });

    // // SORT THE ARRAY BY BASE ORDER
    // navArray.sort((a, b) => {
    //   return a[Object.keys(a)[0]].baseOrder - b[Object.keys(b)[0]].baseOrder;
    // });

    // // FIND THE CURRENT PAGE
    // const currentPageIndex = navArray.findIndex((navItem) => {
    //   return Object.keys(navItem)[0] === 'select';
    // });

    // const nextPageObj = navArray[currentPageIndex + 4];
    // const pageName = Object.keys(nextPageObj)[0];

    // setDisabledPage({ name: pageName, value: true, patientInfo: patientInfo });
    // setDisabledPage({ name: pageName, value: false, patientInfo: patientInfo });

    return `../../../${patientInfo.uid}/payment/selfPay`;
  }
  if (selectedProduct === 'Physician Guided Package' || selectedProduct === 'Vital Package') {
    setDisabledPage({ name: 'guided', value: false, patientInfo: patientInfo });
    return `../../../${patientInfo.uid}/package/concierge`;
  }
  return '../../../home';
}
